import { render, staticRenderFns } from "./driverDetails.vue?vue&type=template&id=03550232&scoped=true&"
import script from "./driverDetails.vue?vue&type=script&lang=js&"
export * from "./driverDetails.vue?vue&type=script&lang=js&"
import style0 from "./driverDetails.vue?vue&type=style&index=0&id=03550232&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03550232",
  null
  
)

export default component.exports